
export const parseDate = (phpDate: any): Date | null => {
  if (phpDate == null) return null
  const unixTimestamp: number = (phpDate.timestamp as number)
  return new Date(unixTimestamp * 1000)
}